import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent, overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AboutUsComponent } from '../../../sharedcomponents/about-us/about-us.component';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../../sharedcomponents/_common/constants/app.constants';
import { userdocserviceopp } from '../../../_services/userservice/user.documentupload.service';

export class CustomModalContext extends BSModalContext {
  public modalData: any = {};
}

@Component({
  templateUrl: './userprofile-document-upload.component-Step1.html',
  providers: [userdocserviceopp, AlertService]
})
export class uploaddocumtuserprofilestep1 implements ModalComponent<CustomModalContext>, OnInit, OnDestroy {
  item: any = '';
  UserDocTypeListCustomer: any = '';
  UserDocTypeListWithTaxid: any = '';
  UserDocTypeListWithoutTaxid: any = '';
  docServiceSubscription: any;
  documentRequired: any = {};
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private userdoc: userdocserviceopp,
    private router: Router,
    public modal: Modal,
    private alertService: AlertService,
    public utilityServ: utilityService,
    public translate: TranslateService,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.documentRequired = this.dialog.context.modalData.DocumentRequired;
  }

  genratelist() {
    this.utilityServ.busy = this.userdoc.getcountrydoucmenttypelistrequest(AppSettings.BaseCountry).subscribe(data => {
      let list = this.userdoc.populateDocumentModelStep1(data);
      this.UserDocTypeListCustomer = list.filter(function(ele) {
        return ele.ForCustomer == true;
      });

      if (this.documentRequired.RequireCustomerID == true || this.documentRequired.RequireCustomerID == 'true') {
        this.UserDocTypeListWithoutTaxid = this.UserDocTypeListCustomer.filter(function(ele) {
          return ele.IsTaxId == false;
        });
      }
      if (this.documentRequired.RequireCustomerTaxID == true || this.documentRequired.RequireCustomerTaxID == 'true') {
        this.UserDocTypeListWithTaxid = this.UserDocTypeListCustomer.filter(function(ele) {
          return ele.IsTaxId == true;
        });
      } else if (
        (this.documentRequired.RequireCustomerTaxID == false || this.documentRequired.RequireCustomerTaxID == 'false') &&
        (this.documentRequired.RequireCustomerTaxIdForUSID == true || this.documentRequired.RequireCustomerTaxIdForUSID == 'true')
      ) {
        this.UserDocTypeListWithTaxid = this.UserDocTypeListCustomer.filter(function(ele) {
          return ele.IsTaxId == true && ele.IssuerConCode.toUpperCase() == AppSettings.BaseCountry; // and country us
        });
      }
    });
  }

  ngOnInit() {
    this.genratelist();
  }
  // Click on List of Documents
  uploadDocStep2(type, selectedData, isImageRequired) {
    const _self = this;
    const target = type;
    this.utilityServ.busy = this.userdoc.getcountrydoucmenttypelistrequest(AppSettings.BaseCountry, target).subscribe(data => {
      console.log('Observer got a next value: ' + data);
      try {
        // docUploadinfo = this.userdoc.populateDocumentModelStep1(data);
        _self.dialog.context.modalData.docUploadinfo = selectedData;
        _self.dialog.context.modalData.docType = target;
        _self.dialog.context.modalData.docUploadinfo.FrontImage = isImageRequired == 'false' ? false : true;
        _self.dialog.context.modalData.Status = true;
        _self.dialog.close();
      } catch (ex) {
        _self.alertService.openErrorAlert(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
        _self.dialog.close();
        console.log('Unable to get document Info' + ex);
      }
    });
  }
  opentermsofuse(objtext) {
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblPrivacyPolicy');
    modalData.URL = objtext;
    modalData.Action = this.translate.instant('Common_lblOk');
    return this.modal.open(AboutUsComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  closePopup() {
    this.dialog.context.modalData.Status = false;
    this.dialog.close();
  }
  ngOnDestroy() {
    this.dialog.context.modalData.Status = false;
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/user-document-upload/userprofile-document-upload.component-Step1.ts